import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalResultadosConversionService } from 'src/app/services/modal-resultados-conversion.service';
import * as _ from 'lodash';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';

@Component({
    selector: 'app-modal-resultados-conversion',
    templateUrl: './modal-resultados-conversion.component.html',
    styleUrls: ['./modal-resultados-conversion.component.scss']
})
export class ModalResultadosConversionComponent implements OnInit, OnDestroy {
    mostrarModal: boolean = false;
    datos: any[] = [];

    // Paginación
    paginationContext: PaginationContext = new PaginationContext();
    datosPaginados: any[] = [];

    // Totales
    sumMontoNeto: number = 0;
    sumMontoBruto: number = 0;

    // Subscripciones
    private mostrarModalSubscription: Subscription;
    private datosSubscription: Subscription;

    constructor(
        private modalResultadosConversionService: ModalResultadosConversionService
    ) { }

    ngOnInit() {
        this.paginationContext.RecordsByPage = 5;

        this.mostrarModalSubscription = this.modalResultadosConversionService.mostrarModal$.subscribe(
            mostrar => {
                this.mostrarModal = mostrar;
                if (mostrar) {
                    this.configurarDatos();
                }
            }
        );

        this.datosSubscription = this.modalResultadosConversionService.datos$.subscribe(
            datos => {
                this.datos = datos;
                if (this.mostrarModal) {
                    this.configurarDatos();
                }
            }
        );
    }

    ngOnDestroy() {
        if (this.mostrarModalSubscription) {
            this.mostrarModalSubscription.unsubscribe();
        }
        if (this.datosSubscription) {
            this.datosSubscription.unsubscribe();
        }
    }

    private configurarDatos() {
        if (!this.datos || this.datos.length === 0) {
            return;
        }

        this.paginationContext.RecordsCount = this.datos.length;
        this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage);
        this.paginationContext.CurrentPage = 1;

        this.showPage(1);
        this.calcularTotales();
    }

    showPage(pageNumber: number) {
        this.paginationContext.CurrentPage = pageNumber;
        const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
        this.datosPaginados = _.slice(this.datos, start, start + this.paginationContext.RecordsByPage);
    }

    onPageChange(context: PaginationContext) {
        this.showPage(context.RequestedPage);
    }

    private calcularTotales() {
        if (!this.datos || this.datos.length === 0) {
            this.sumMontoNeto = 0;
            this.sumMontoBruto = 0;
            return;
        }

        this.sumMontoNeto = this.datos.reduce((sum, item) => {
            return sum + (item.monto_total_neto ? item.monto_total_neto : 0);
        }, 0);

        this.sumMontoBruto = this.datos.reduce((sum, item) => {
            return sum + (item.monto_total ? item.monto_total : 0);
        }, 0);
    }

    cerrarModal() {
        this.modalResultadosConversionService.ocultarModal();
    }
}



